import fetchData, { APIURL, getData, postData } from "../fetch";


/**
 * @typedef {{
 *  id: string
 *  title: string
 *  make: string 
 *  model: string
 *  min_year: string
 *  max_year: number
 *  transmission_type: string
 *  fuel_type: string
 *  body_type: string
 *  min_year: number
 *  max_year: number
 *  seating_capacity: ?number
 *  engine_cc: number
 *  payload_tonnes: number 
 *  drivetrain: ?string
 *  description: string
 *  vehicles: import("./vehicles").VehicleObject[]
 * }} VehicleCategoryObject
 */





/**
 * 
 * @param {VehicleCategoryObject} data 
 * @returns {Promise<{code: number, message: string, category: VehicleCategoryObject}>}
 */
const createCategory = data => postData({ url: `${APIURL}/vehicle-categories`, data })


/**
 * get category details
 * @param {String} id 
 * @param {string[]} include
 * @returns {Promise<{code: number, message: string, category: VehicleCategoryObject}>}
 */
const getCategory = (id, include = []) => fetchData({ url: `${APIURL}/vehicle-categories/${id}`, data: { include: include.join(",") } })


/**
 * @param {VehicleCategoryObject} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, category: VehicleCategoryObject}>}
 */
const updateCategory = (data, id) => postData({ url: `${APIURL}/vehicle-categories/${id}`, data })

/**
 * 
 * @param {boolean} getAll If to get the expanded list  
 * @returns {Promise<{code: number, message: string, categories: VehicleCategoryObject[]}>}
 */
const getCategories = () => getData({ url: `${APIURL}/vehicle-categories` });



export {
    getCategory,
    getCategories,
    createCategory,
    updateCategory,
}